<template>
    <div>
        <component :is="'style'">
            :root {
                --primary-color: {{ primaryColor }};
                --primary-hover-color: {{ primaryColor }};
                --background-color: {{ backgroundColor }};
            }
        </component>
        <div>
            <router-view />
            <Footer />
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'pinia'
    import { useShopStore } from '@/stores/shop'
    
    import Footer from '@/components/Footer'

    export default {
        metaInfo() {
            return {
                title: this.title,
                titleTemplate: '%s | Tixgo'
            }
        },
        data() { 
            return {
                error: null,
                title: null,
            }
        },
        components: {
            Footer,
        },
        computed: {
            primaryColor() {
                return this.getShop().theme.primary_color ? this.getShop().theme.primary_color : '#CA355B';
            },
            backgroundColor() {
                return this.getShop().theme.background_color ? this.getShop().theme.background_color : '#F2F5F7';
            },
        },
        methods: {
            ...mapActions(useShopStore, ['getShop','setShop']),
            getHost: function() {
                this.$axios.get("https://api.tixgo.nl/host/" + this.$route.params.host)
                    .then( response => {
                        if (response.data) {
                            this.setShop(response.data);
                            this.title = this.getShop().organisation.name;
                        }
                    }
                ).catch((reason) => {
                    console.log(reason);
                });
            },
        },
        created() {
            this.getHost();
        }
    }
</script>